import { makeSearchInput } from 'components/common/SearchInput';
import { CommonTranslationKeys } from 'intl/keys';
import { EntityLabel } from 'components/common/SearchInput/types';
import { WithDataGridApi } from 'components/common/withDataGridApi';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import { useUsers, withUsers } from 'components/dataProviders/withUsers';
import { MemoTableAnchor } from 'components/tableAnchor';
import { UserDataGridActions } from 'components/user/UserDataGrid/UserDataGridActions';
import { UserTable } from 'components/user/table';
import { useAppNavigation } from 'contexts/navigation';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { ReactElement, useCallback } from 'react';
import { useProjectId } from 'store/project';
import { useInitialSearchEffect } from '../../../hooks/search/useInitialSearch';
import { useSearchUpdate } from '../../../hooks/search/useSearchUpdate';

const UserSearchInput = makeSearchInput(EntityLabel.user);

const header = {
  id: 'create-user-button',
  textId: CommonTranslationKeys.buttonCreateUser,
  dataQaId: 'create-user-button',
};

function Users(): ReactElement {
  const { goToCreateUser } = useAppNavigation();
  const { loading, setSearchPhrase } = useUsers();
  const { canCreateUser } = usePermissions();

  const projectId = useProjectId();
  useSearchUpdate(EntityLabel.user, setSearchPhrase);
  useInitialSearchEffect(projectId, EntityLabel.user, setSearchPhrase);

  return (
    <WithDataGridApi>
      <MemoTableAnchor
        canCreate={canCreateUser}
        creationAction={goToCreateUser}
        TableComponent={UserTable}
        loading={loading}
        headerWithCreation={header}
        SearchInput={UserSearchInput}
        DataGridActions={UserDataGridActions}
      />
    </WithDataGridApi>
  );
}

export const MemoUsers = React.memo(
  composeHOCs(withProcessesData, withUsers)(Users)
);
